import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { FadeIn, PageHero } from '../components/PageComponents';
import { timelineData } from '../data/mockData';

const HistoriePage = () => (
  <main className="pt-28 min-h-screen">
    <SEO title="Ons Verhaal & Historie - Staffing Force" description="De geschiedenis van Staffing Force sinds de oprichting in 2007 in Hilversum tot B Corp certificering. Ontdek ons verhaal." keywords="staffing force historie, ons verhaal, oprichting 2007, B Corp" />
    <PageHero label="Ons verhaal" title="Historie" description="Van een start in Hilversum in 2007 tot een toonaangevend duurzaam detacheringsbureau vanuit ons kantoor in Amsterdam." image="https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=1920&q=85&auto=format&fit=crop" />
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-px bg-[#00897B]/20" />
          {timelineData.map((item, i) => (
            <FadeIn key={item.year} delay={i * 0.1}>
              <div className="flex gap-8 mb-12 last:mb-0">
                <div className="relative flex-shrink-0">
                  <div className="w-16 h-16 rounded-full bg-[#00897B] flex items-center justify-center text-white font-bold text-sm shadow-lg">{item.year}</div>
                </div>
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 flex-1">
                  <h2 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h2>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
    <section className="py-20 bg-[#00897B]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <FadeIn>
          <h2 className="text-3xl font-bold text-white mb-6">Wilt u meer weten over Staffing Force?</h2>
          <Link to="/over-ons" className="bg-white text-[#00897B] px-8 py-3 rounded font-semibold text-sm transition-all hover:-translate-y-0.5 inline-flex items-center gap-2">Over ons <ArrowRight size={16} /></Link>
        </FadeIn>
      </div>
    </section>
  </main>
);

export default HistoriePage;
